import { components } from "@/api-schema";
import { formatDateToApi } from "@/common/helpers/format-date";

type VehicleBlockReason = components["schemas"]["VehicleBlockCreateBody"]["reason"];
type VehicleBlockCreatePayload = components["schemas"]["VehicleBlockCreateBody"];

export function createVehicleBlockPayload(
  vehicleUuid: string,
  blockedByUuid: string,
  reason: VehicleBlockReason,
  durationInDays: number,
): VehicleBlockCreatePayload {
  const blockedFrom = new Date();
  const blockedUntil = new Date();
  blockedUntil.setDate(blockedUntil.getDate() + durationInDays);

  return {
    vehicle: vehicleUuid,
    blockedBy: blockedByUuid,
    reason,
    blockedFrom: formatDateToApi(blockedFrom),
    blockedUntil: formatDateToApi(blockedUntil),
  };
}
